import { render } from "./ImageCarousel.vue?vue&type=template&id=acbe14ae&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=acbe14ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-acbe14ae"

export default script